<!--
 * @Author: houmy
 * @Date: 2023-09-18 21:31:01
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-02 09:33:20
 * @FilePath: \zx-home\src\views\Products.vue
 * @Description: 
 * 
-->

<template>
    <div class="page">
        <Contact></Contact>
        <img class="newsBanner" src="../assets/img/products/banner.png" alt="">
        <div class="newsPageList news home-box flex-row">
            <div class="productWrap w12">
                <div class="peoduct-left">
                    <div class="page-title page-title-sub">
                        <i></i>
                        <span>产品分类</span>
                    </div>
                    <ul class="productTab">
                        <li :class="{ 'active': isActive == 1 }" @click="changeType(1)">
                            智能感知
                        </li>
                        <li :class="{ 'active': isActive == 2 }" @click="changeType(2)">
                            智能驾驶
                        </li>
                        <li :class="{ 'active': isActive == 3 }" @click="changeType(3)">
                            智能硬件
                        </li>
                        <li :class="{ 'active': isActive == 4 }" @click="changeType(4)">
                            智慧云平台
                        </li>
                    </ul>
                </div>
                <div class="product-right">
                    <div class="page-title page-title-sub">
                        <i></i>
                        <span>{{title}}</span>
                    </div>
                    <ul class="producRightMain">
                        <li class="flex-col" v-for="(item, index) in productArr" @click="toDetail(item, index)">
                            <img class="newsImg" :src="getImagePath(item.img)" />
                            <h4>{{ item.title.indexOf('自动驾驶')>-1?'自驾'+item.title.split('自动驾驶')[1]:item.title }}</h4>
                            <p>
                                {{ item.desc }}
                            </p>
                        </li>

                    </ul>
                </div>
            </div>

        </div>

    </div>
</template>
    
<script>
import Contact from '../components/Contact.vue'
import productJson from '@/assets/data/productList.json'
export default {
    components: {
        Contact
    },
    data() {
        return {
            productArr: [],
            isActive: 1,
            title: '智能感知'
        };
    },
    watch:{
    '$route'(val, from) {
      if(val.query.type){
        this.isActive = val.query.type?val.query.type:1
        this.title = this.isActive == 1 ? '智能感知' : this.isActive == 2 ? '智能驾驶' : this.isActive == 3 ? '智能硬件' :  '智慧云平台'
        this.productArr = productJson[`list${this.isActive}`]
        this.$nextTick(() => {
            window.scrollTo(0, 0)
        })
      }
    }
  },

    mounted() {
        this.isActive = this.$route.query.type?this.$route.query.type:1
        this.title = this.isActive == 1 ? '智能感知' : this.isActive == 2 ? '智能驾驶' : this.isActive == 3 ? '智能硬件' :  '智慧云平台'
        this.productArr = productJson[`list${this.isActive}`]
        this.$nextTick(() => {
            window.scrollTo(0, 0)
        })
    },
    methods: {
        getImagePath(imageName) {
            return require(`@/assets${imageName}`);
        },
        // 切换类型
        changeType(type) {
            this.isActive = type
            this.type = type
            switch (type) {
                case 1:
                    this.productArr = productJson.list1
                    this.title = '智能感知'
                    break;
                case 2:
                    this.productArr = productJson.list2
                    this.title = '智能驾驶'
                    break;
                case 3:
                    this.productArr = productJson.list3
                    this.title = '智能硬件'
                    break;
                case 4:
                    this.productArr = productJson.list4
                    this.title = '智慧云平台'
                    break;
                default:
                    break;
            }

        },
        // 跳转详情
        toDetail(item, index) {
            // localStorage.setItem('productDetail', JSON.stringify(item))
            this.$router.push({
                path: '/productsDetail',
                query: {
                    id: item.id,
                    type: item.type,
                }
            })
        }

    }
};
</script>
    
<style scoped></style>
    


// WEBPACK FOOTER //
// src/views/Products.vue